import React, { useState, useEffect } from 'react';

import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";

import "./stylesheadersbackgroundimage.css";

import axios from 'axios';
import { useSelector } from 'react-redux'; 
import { useTranslation } from 'react-i18next';

const Header = () => {

  const [devices, setDevices] = useState('')
  const [clusters, setClusters] = useState('')
  const [totalnumberacquisition, setTotalnumberacquisition] = useState('')
  
  const token = useSelector((state) => state.userLogin.userInfo.token);

  ////////////
  const { t, i18n } = useTranslation();  // Destructure i18n from useTranslation

  useEffect(() => {
      const storedLanguage = localStorage.getItem('selectedLanguageAFS');
      if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);  // Use i18n to change language
      }
  }, [i18n]);
  ////////////

  useEffect(() => {

    const fetchData = async () => {
      try {
        const config = {
          headers: {
            'Content-type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
          
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/sensors/number-sensors/`, config);
        
        setDevices(response.data.count);

      } catch (error) {

      }
    };

    fetchData(); 
  }, [token]);

  useEffect(() => {

    const fetchData = async () => {
      try {
        const config = {
          headers: {
            'Content-type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
          
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/sensors/total-grape-counted/`, config);
        
        setClusters(response.data.count);

      } catch (error) {

      }
    };

    fetchData(); 
  }, [token]);

  useEffect(() => {

    const fetchData = async () => {
      try {
        const config = {
          headers: {
            'Content-type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
          
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/sensors/total-number-acquisition/`, config);
        
        setTotalnumberacquisition(response.data.count);

      } catch (error) {

      }
    };

    fetchData(); 
  }, [token]);

  return (
    <>
      <div className="header pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <Row>
              <Col lg="6" xl="4">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          {t('Number of devices')}
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                          {devices && (
                            <>
                              {devices}
                            </>
                          )}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                          <i class="fa-solid fa-satellite-dish"></i>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="4">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          {t('Total Number of clusters')}
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                        {clusters && (
                            <>
                              {clusters}
                            </>
                          )}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-primary text-white rounded-circle shadow">
                          <i class="fa-solid fa-bullseye"></i>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="4">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          {t('Total Number of Data Acquisitions')}
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">                        
                          {totalnumberacquisition && (
                              <>
                                {totalnumberacquisition}
                              </>
                            )}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                          <i class="fa-solid fa-list-ol"></i>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Header;
